import { Translate } from '@/common/components/Translate/Translate';
import { i18n } from '@/common/i18n';
import { TFAQProps } from '@coverflex-tech/hypernova';

export function tArray<T>(
  key: string,
  values: Record<string, string | number> = {}
) {
  if (i18n.exists(key)) {
    const content = i18n.t(key, { returnObjects: true, ...values }) as
      | string
      | T[];
    if (Array.isArray(content)) {
      return content;
    }
  }

  return [];
}

export const buildTranslatedFaqs = (i18nKey: string) =>
  tArray<TFAQProps>(i18nKey).map((faq) => ({
    question: <Translate>{faq.question}</Translate>,
    answer: <Translate>{faq.answer}</Translate>,
  }));
